$(document).ready(function() {
	$('body').on('click', '.alert .icon-cross', function() {
		$(this).closest('.alert').hide();
	});
});